export const PARKING_TYPE = {
  free: {
    value: "free",
    text: "あり（無料）"
  },
  paid: {
    value: "paid",
    text: "あり（有料）"
  },
  none: {
    value: "none",
    text: "なし（近隣のコインパーキング等をご自身でご利用ください）"
  }
} as const;
export type ParkingTypeValue =
  | typeof PARKING_TYPE[keyof typeof PARKING_TYPE]["value"]
  | null;
